module.exports = __webpack_public_path__ + "img/1.edded6a5.jpg";